exports = module.exports = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.java.hljs[data-v-042a29b5] {\n  color: #444;\n  background: #ffffff !important;\n}\n[data-v-042a29b5] .el-dialog__body {\n  padding: 0 20px 10px 20px !important;\n}\n.pagebox[data-v-042a29b5] {\n  text-align: right;\n  margin-top: 15px;\n}\n", ""]);

// exports
